import React from "react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export default function StatCard({ icon: Icon, label, value, sub, accent = "primary", testId, className }) {
  const accents = {
    primary: "text-primary bg-primary/10",
    green: "text-brand-green bg-brand-green/10",
    amber: "text-amber-500 bg-amber-500/10",
    purple: "text-purple-500 bg-purple-500/10",
    red: "text-destructive bg-destructive/10",
  };
  return (
    <Card
      data-testid={testId}
      className={cn(
        "p-6 border-border bg-card hover:shadow-sm transition-all duration-200 hover:-translate-y-[2px]",
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-widest text-muted-foreground">{label}</p>
          <p className="mt-2 text-3xl font-display font-semibold tracking-tight tabular-nums">
            {value}
          </p>
          {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
        </div>
        {Icon && (
          <div className={cn("h-10 w-10 rounded-lg flex items-center justify-center", accents[accent])}>
            <Icon size={18} strokeWidth={2.2} />
          </div>
        )}
      </div>
    </Card>
  );
}
